import { arrChunk } from 'assets/constant';
import EmptyComponent from 'components/common/EmptyComponent';
import { PaginationCustom } from 'components/common/pagination';
import { useAdminReportQuery } from 'hooks/report/useAdminReportQuery';
import { useReport } from 'hooks/report/useReport';
import { ReportSelectLayout } from 'pages/student/report/common/ReportSelectLayout';
import { ReportStudentTableItem } from 'pages/student/report/teacher/ReportStudentTableItem';
import { useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import { useNavigate } from 'react-router';
import { useRecoilState } from 'recoil';
import { studentReportState } from 'recoil/report/student/studentReportState';
import { studentPagination } from 'recoil/report/studentPagination';
import { teacherReportState } from 'recoil/report/teacher/teacherReportState';
import { teacherStudentState } from 'recoil/report/teacher/teacherStudentState';

export const ReportStudentListAdmin = () => {
  const navigate = useNavigate();
  const { semesterSelector, departmentSelector, reportSearchForm, searchInputRef } = useReport();

  const [studentState, setStudentState] = useRecoilState(teacherStudentState);
  const [reportState, setReportState] = useRecoilState(studentReportState);
  const [reacherReportState, setReacherReportState] = useRecoilState(teacherReportState);
  const [filterData, setFilterData] = useState([]);
  const { 관리자_학생목록_정보, 관리자_학생목록_로딩 } = useAdminReportQuery();
  const [currentPage, setCurrentPage] = useRecoilState(studentPagination);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const searchUser = 관리자_학생목록_정보?.data.filter(
      (item) =>
        item.student_number.includes(searchInputRef.current.value) ||
        item.student_name.includes(searchInputRef.current.value)
    );
    setCurrentPage(1);
    setFilterData(searchUser);
  };

  useEffect(() => {
    if (관리자_학생목록_정보?.data) {
      setFilterData(관리자_학생목록_정보?.data);
    }
  }, [관리자_학생목록_정보]);

  return (
    <section>
      <div className='row'>
        <div className='col'>
          <div className='position-relative'>
            {/* 셀렉트 박스 */}
            <ReportSelectLayout>
              <div className='d-flex align-items-center' style={{ width: '40%' }}>
                {semesterSelector(true, setReportState, reportState)}
              </div>
              <div className='d-flex align-items-center flex-grow-1 ms-2'>
                {reportSearchForm(handleOnSubmit, !reportState)}
              </div>
            </ReportSelectLayout>

            {/* {!관리자_학생목록_정보?.data && (
              <div className='card p-3 w-100' style={{ height: '100px' }}>
                <SpinnerLoading />
              </div>
            )} */}

            {reportState ? (
              <section>
                <h3 className='fw-bold fz-20 lh-24 mb-4'>학생 성과보고서 현황</h3>
                <div className='card p-3'>
                  <Table>
                    <thead>
                      <tr className='fz-14'>
                        <th className='py-3 fz-14'>번호</th>
                        <th className='py-3 text-start'>학번/사번 &#40;로그인ID&#41;</th>
                        <th className='py-3 text-start'>이름</th>
                        <th className='py-3 text-start' colSpan={2}>
                          학과/과목
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* {관리자_학생목록_정보?.data?.map(
                        ({ student_id, student_number, student_name, sub_division }, index) => (
                          <ReportStudentTableItem
                            key={student_id}
                            index={index}
                            classNumber={student_number}
                            name={student_name}
                            department={sub_division}
                            onClick={() => {
                              setStudentState({ term_id: reportState?.value, student_id });
                              navigate(`${student_id}`);
                            }}
                          />
                        )
                      )} */}
                      {!arrChunk(filterData, 10)[currentPage - 1] ? (
                        <tr>
                          <td colSpan={10}>
                            <EmptyComponent text='검색 결과가 없습니다.' transform></EmptyComponent>
                          </td>
                        </tr>
                      ) : (
                        arrChunk(filterData, 10)[currentPage - 1]?.map(
                          ({ student_id, student_number, student_name, sub_division }, index) => (
                            <ReportStudentTableItem
                              key={student_id}
                              index={
                                currentPage > 0 ? (currentPage - 1) * 10 + (index + 1) : currentPage - 1 + (index + 1)
                              }
                              classNumber={student_number}
                              name={student_name}
                              department={sub_division}
                              onClick={() => {
                                setStudentState({ term_id: reportState?.value, student_id });
                                navigate(`${student_id}`, {
                                  state: { student_name, student_number, sub_division, student_id },
                                });
                              }}
                            />
                          )
                        )
                      )}
                    </tbody>
                  </Table>
                  <div className='d-flex align-items-center justify-content-center position-relative'>
                    <p className='float-left position-absolute top-left-50 fz-14'>
                      전체 게시물수 : {filterData.length} 전체 페이지 : {currentPage}&nbsp;/&nbsp;
                      {arrChunk(filterData, 10).length}
                      {/* {Math.ceil(noticeList.length / 5)} */}
                    </p>
                    <PaginationCustom
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      // data={adminAllUserData?.content}
                      importantDataLength={filterData?.length}
                      itemsCountPerPage={10}
                    />
                  </div>
                </div>
              </section>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
